import Loading from "components/center-loading";
import Input from "components/input";
import { Dialog, SelectBox, Toggle } from "components/uikit-adapter/index";
import PropTypes from "prop-types";
import { Component } from "react";
import intl from "react-intl-universal";
import ReactTags from "react-tag-autocomplete";
import Fetch from "utils/fetch";

import "./supplier-form.css";
import Button from "components/button";
import { GeneralSettingParameter } from "models/generalSetting/generalSetting";
import { getGeneralSettingValue } from "services/general-settings/general-settings";
import { formatErrorMessage } from "utils/handle-error";
import { getSupplierCodeFormated } from "utils/supplier-code-format";

const getTiposUnidade = () => [
  { Id: 1, Description: intl.get("commons.supplierType.external") },
  { Id: 2, Description: intl.get("commons.supplierType.supplyingUnit") },
  { Id: 3, Description: intl.get("commons.supplierType.externalWarehouse") },
  { Id: 4, Description: intl.get("commons.supplierType.consigneeStock") },
  { Id: 5, Description: intl.get("commons.supplierType.brewery") },
];

class SupplierForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFetching: false,
      supplier: {
        Supplier: {
          SupplierNickName: "",
          AutoAcceptLoadComposition: false,
          SupplierType: null,
        },
        User: {},
        InternationalSupplierGroup: {},
      },
      suppliers: [],
      user: {},
      users: [],
      internationalSupplierGroups: [],
      origins: [],
      isOriginsLoading: props.editMode,
      originsLoadFailed: false,
    };
  }

  componentDidMount() {
    this.loadUsers();
    this.loadInternationalSupplierGroups();

    const editMode = this.props.editMode;
    if (editMode) {
      this.searchSupplierGoupById();
    } else {
      this.loadSuppliers();
    }
  }

  startFetching = () => {
    this.setState({
      isFetching: true,
    });
  };

  stopFetching = () => {
    this.setState({
      isFetching: false,
    });
  };

  loadSuppliers = () => {
    this.startFetching();
    Fetch.get(`/fornecedor/buscaFornecedores`)
      .then((response) => {
        this.setState({ suppliers: response.data });
      })
      .finally(() => this.stopFetching());
  };

  loadUsers = () => {
    this.startFetching();
    Fetch.get(`/usuario/buscaUsuariosFornecedor`)
      .then((response) => {
        this.setState({ users: response.data });
      })
      .finally(() => this.stopFetching());
  };

  loadInternationalSupplierGroups = () => {
    this.startFetching();
    Fetch.get(`/international-supplier-groups`)
      .then((response) => {
        this.setState({ internationalSupplierGroups: response.data });
      })
      .finally(() => this.stopFetching());
  };

  searchSupplierGoupById = () => {
    const id = this.props.idEdit;
    this.startFetching();
    Fetch.get(`/supplier-users/${id}`)
      .then((response) => this.proccessData(response.data))
      .catch((e) => {
        this.proccessErro(e);
        this.setState({ isOriginsLoading: false });
      })
      .finally(() => this.stopFetching());
  };

  proccessData = (data) => {
    const {
      Id,
      SupplierId,
      UserId,
      UserName,
      SupplierCode,
      SupplierCompanyName,
      SupplierCnpj,
      SupplierNickName,
      SupplierCodeMdg,
      AutoAcceptLoadComposition,
      HasAuroraBusinessUnities,
      InternationalSupplierGroupId,
      InternationalSupplierGroupName,
      SupplierType,
    } = data;

    let supplierCodeMdg = SupplierCodeMdg;

    if (!SupplierCodeMdg) {
      supplierCodeMdg = "";
    }

    this.setState(
      {
        supplier: {
          Id: Id,
          Supplier: {
            Id: SupplierId,
            SupplierNickName: SupplierNickName,
            SupplierCode: SupplierCode,
            SupplierCnpj: SupplierCnpj,
            SupplierCompanyName: SupplierCompanyName,
            SupplierCodeFormated: getSupplierCodeFormated(
              supplierCodeMdg,
              SupplierCode,
              HasAuroraBusinessUnities
            ),
            AutoAcceptLoadComposition: AutoAcceptLoadComposition,
            SupplierType: SupplierType,
            SupplierTypeLocked:
              SupplierType !== null && SupplierType !== undefined && SupplierType !== "",
          },
          User: {
            Id: UserId,
            Name: UserName,
          },
          InternationalSupplierGroup: {
            Id: InternationalSupplierGroupId,
            Name: InternationalSupplierGroupName,
          },
        },
      },
      () => this.loadOrigins(SupplierId)
    );
  };

  getUseFilterDefault = () => {
    try {
      return JSON.parse(localStorage.getItem("filterMyItemsOnly")) === true;
    } catch (_e) {
      return false;
    }
  };

  formatOrigins = (data) => {
    if (!Array.isArray(data)) return [];

    return data
      .map((origin) => ({
        id: origin.id ?? origin.Id ?? 0,
        name: origin.name ?? origin.Name ?? "",
      }))
      .filter((origin) => origin.name.trim());
  };

  loadOrigins = (supplierId) => {
    if (!supplierId) {
      this.setState({ origins: [], isOriginsLoading: false, originsLoadFailed: false });
      return Promise.resolve();
    }

    const useFilterDefault = this.getUseFilterDefault();
    this.startFetching();
    this.setState({ isOriginsLoading: true, originsLoadFailed: false });

    return Fetch.get(`/fornecedor/${supplierId}/origins?useFilterDefault=${useFilterDefault}`)
      .then((response) =>
        this.setState({ origins: this.formatOrigins(response.data), originsLoadFailed: false })
      )
      .catch((e) => {
        this.setState({ originsLoadFailed: true });
        this.proccessErro(e);
      })
      .finally(() => this.setState({ isOriginsLoading: false }, this.stopFetching));
  };

  proccessErro = (exception) => {
    try {
      const erro = formatErrorMessage(exception);
      this.props.handleFeedback(erro);
    } catch (_e) {
      this.props.handleFeedback(intl.get("feedbacks.serverError"));
    }
  };

  changeValueNickname = (event) => {
    const value = event.currentTarget.value;

    this.setState((prevState) => ({
      supplier: {
        ...prevState.supplier,
        Supplier: {
          ...prevState.supplier.Supplier,
          SupplierNickName: value,
        },
      },
    }));
  };

  changeAutoAcceptLoadComposition = (prop, value) => {
    this.setState((prevState) => ({
      supplier: {
        ...prevState.supplier,
        Supplier: {
          ...prevState.supplier.Supplier,
          [prop]: value,
        },
      },
    }));
  };

  save = () => {
    if (this.state.isOriginsLoading || this.state.originsLoadFailed) return Promise.resolve();

    const model = this.state.supplier;

    const up = {
      Id: model.Id ? model.Id : 0,
      UserId: model.User.Id,
      SupplierId: model.Supplier.Id,
      SupplierNickName: model.Supplier.SupplierNickName,
      AutoAcceptLoadComposition: model.Supplier.AutoAcceptLoadComposition,
      SupplierType: model.Supplier.SupplierType,
      internationalSupplierGroupId: model.InternationalSupplierGroup?.Id,
    };

    this.startFetching();
    return Fetch.post(`/supplier-users`, up)
      .then(() => Fetch.post(`/fornecedor/${model.Supplier.Id}/origins`, this.state.origins))
      .then(this.props.handleRefresh)
      .then(() => this.props.handleFeedback(intl.get("feedbacks.savedRegister")))
      .catch((e) => this.proccessErro(e))
      .finally(() => this.stopFetching());
  };

  updateUserSelectValue = (prop, value) => {
    this.setState((prevState) => ({
      supplier: {
        ...prevState.supplier,
        User: {
          ...prevState.supplier.User,
          [prop]: value,
        },
      },
    }));
  };

  updateInternationalSupplierGroupSelectValue = (prop, value) => {
    this.setState((prevState) => ({
      supplier: {
        ...prevState.supplier,
        User: {
          ...prevState.supplier.User,
        },
        InternationalSupplierGroup: {
          ...prevState.supplier.InternationalSupplierGroup,
          [prop]: value,
        },
      },
    }));
  };

  updateSupplierSelectValue = (prop, value) => {
    this.setState(
      (prevState) => ({
        origins: [],
        isOriginsLoading: prop === "Id" && Boolean(value),
        originsLoadFailed: false,
        supplier: {
          ...prevState.supplier,
          Supplier: {
            ...prevState.supplier.Supplier,
            [prop]: value,
          },
        },
      }),
      () => {
        if (prop === "Id") this.loadOrigins(value);
      }
    );
  };

  updateSupplierUnitTypeValue = (value) => {
    this.setState((prevState) => ({
      supplier: {
        ...prevState.supplier,
        Supplier: {
          ...prevState.supplier.Supplier,
          SupplierType: value?.Id,
        },
      },
    }));
  };

  onDeleteOrigin = (index) => {
    const { supplier, isOriginsLoading } = this.state;
    if (!supplier.Supplier.Id || isOriginsLoading || !this.props.profileAdminOrMasterData()) return;

    this.setState((prevState) => ({
      origins: prevState.origins.filter((_, originIndex) => originIndex !== index),
    }));
  };

  onAddOrigin = (origin) => {
    const { supplier, isOriginsLoading } = this.state;
    const name = origin?.name?.trim();

    if (
      !supplier.Supplier.Id ||
      isOriginsLoading ||
      !name ||
      !this.props.profileAdminOrMasterData()
    )
      return;

    this.setState((prevState) => {
      const originExists = prevState.origins.some((item) => item.name === name);
      if (originExists) return null;

      return {
        origins: prevState.origins.concat({
          id: origin.id ?? origin.Id ?? 0,
          name,
        }),
      };
    });
  };

  render() {
    const {
      supplier,
      suppliers,
      users,
      isFetching,
      internationalSupplierGroups,
      origins,
      isOriginsLoading,
      originsLoadFailed,
    } = this.state;
    console.log(supplier.Supplier);
    const { open, editMode, profileAdminOrMasterData } = this.props;
    const hasSupplier = Boolean(supplier.Supplier.Id);
    const canEditOrigins = hasSupplier && !isOriginsLoading && profileAdminOrMasterData();
    let originsPlaceholder = "";
    if (!hasSupplier) {
      originsPlaceholder = intl.get(
        "master-data.suppliers.ableSupplier.actions.selectSupplierForOrigins"
      );
    } else if (canEditOrigins) {
      originsPlaceholder = intl.get("master-data.suppliers.ableSupplier.actions.addSupplierOrigin");
    }
    return (
      <div>
        <Loading isLoading={isFetching} />
        <Dialog
          title={
            editMode
              ? intl.get("master-data.suppliers.ableSupplier.actions.editSupplier")
              : intl.get("master-data.suppliers.ableSupplier.actions.newSupplier")
          }
          contentStyle={{ width: "600px" }}
          open={open}
          autoScrollBodyContent
        >
          <div className="line-1-columns">
            <SelectBox
              required
              name="User"
              label={intl.get("master-data.suppliers.ableSupplier.actions.supplierGroupName")}
              placeholder={intl.get("master-data.suppliers.ableSupplier.actions.supplierGroupName")}
              valueKey="Id"
              labelKey="Nome"
              value={supplier.User.Id}
              options={users}
              onChange={(value) => this.updateUserSelectValue("Id", value.Id)}
              disabled={!profileAdminOrMasterData}
              searchable
              openOnFocus
            />
          </div>

          <div className="line-1-columns">
            <SelectBox
              name="InternationalSupplierGroup"
              label={intl.get(
                "master-data.suppliers.ableSupplier.actions.InternationalSupplierGroupName"
              )}
              valueKey="Id"
              labelKey="Name"
              value={supplier.InternationalSupplierGroup?.Id}
              options={internationalSupplierGroups}
              onChange={(value) =>
                this.updateInternationalSupplierGroupSelectValue("Id", value?.Id)
              }
              disabled={!profileAdminOrMasterData}
              searchable
              clearable
            />
          </div>

          <div className="line-1-columns option-item">
            {editMode && (
              <Input
                disabled
                label={intl.get("commons.supplier")}
                value={`${supplier.Supplier.SupplierCodeFormated} - ${supplier.Supplier.SupplierCompanyName} - ${supplier.Supplier.SupplierCnpj}`}
              />
            )}
            {!editMode && (
              <SelectBox
                required
                name="Supplier"
                label={intl.get("commons.supplier")}
                placeholder={intl.get("commons.supplier")}
                valueKey="Id"
                labelKey="Descricao"
                value={supplier.Supplier.Id}
                options={suppliers}
                onChange={(value) => this.updateSupplierSelectValue("Id", value.Id)}
                disabled={!profileAdminOrMasterData}
                searchable
                openOnFocus
              />
            )}
          </div>
          <div className="line-1-columns">
            <SelectBox
              required
              label={intl.get("master-data.general-configuration.unityType")}
              placeholder={intl.get("master-data.general-configuration.unityType")}
              name="TipoUnidade"
              value={supplier.Supplier.SupplierType}
              valueKey="Id"
              labelKey="Description"
              onChange={this.updateSupplierUnitTypeValue}
              options={getTiposUnidade()}
              width="100%"
              disabled={supplier.Supplier.SupplierTypeLocked || !profileAdminOrMasterData()}
            />
          </div>
          <div className="line-1-columns supplier-origins">
            <p className="tag-label">
              {intl.get("master-data.suppliers.ableSupplier.actions.supplierOrigins")}
            </p>
            <ReactTags
              tags={origins}
              onDelete={this.onDeleteOrigin}
              onAddition={this.onAddOrigin}
              allowNew={canEditOrigins}
              allowBackspace={canEditOrigins}
              placeholderText={originsPlaceholder}
              delimiters={["Enter", "Tab"]}
              inputAttributes={{ maxLength: 120, disabled: !canEditOrigins }}
            />
          </div>
          <div className="line-1-columns">
            <Input
              required
              name="SupplierNickName"
              label={intl.get("commons.factory")}
              value={supplier.Supplier.SupplierNickName}
              onChange={this.changeValueNickname}
              disabled={!profileAdminOrMasterData}
            />
          </div>
          <div className="line-1-columns">
            {editMode &&
              getGeneralSettingValue(GeneralSettingParameter.LoadCompositionNewFlow) &&
              profileAdminOrMasterData && (
                <Toggle
                  className="toggle-accept-load-comp"
                  name={"AutoAcceptLoadComposition"}
                  label={intl.get(
                    "master-data.general-configuration.acceptChargeCompositionAutomatic"
                  )}
                  value={supplier.Supplier.AutoAcceptLoadComposition}
                  onChange={(value) =>
                    this.changeAutoAcceptLoadComposition("AutoAcceptLoadComposition", value.checked)
                  }
                  thumbSwitchedStyle={{ backgroundColor: "var(--color-action-default)" }}
                  trackSwitchedStyle={{ backgroundColor: "var(--color-neutral-200)" }}
                  labelStyle={{ color: "var(--color-contrast-brand)" }}
                  labelPosition="right"
                />
              )}
          </div>
          <div className="supplier-form-footer">
            <Button
              buttonType="default"
              value={intl.get("geral.buttonsDefault.cancel")}
              onClick={() => {
                this.props.handleClose();
              }}
              className="supplier-form-footer-button"
            />
            {profileAdminOrMasterData && (
              <Button
                buttonType="primary"
                value={intl.get("geral.buttonsDefault.save")}
                className="supplier-form-footer-button"
                disabled={isOriginsLoading || originsLoadFailed}
                onClick={this.save}
              />
            )}
          </div>
        </Dialog>
      </div>
    );
  }
}

SupplierForm.propTypes = {
  editMode: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleFeedback: PropTypes.func.isRequired,
  handleRefresh: PropTypes.func.isRequired,
  idEdit: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  profileAdminOrMasterData: PropTypes.func.isRequired,
};

export default SupplierForm;
